import React                from "react";
import PropTypes            from "prop-types";
import Flux                 from "../../flux/Flux";
import VideoTile            from "../Grid2/Tiles/VideoTile";
import Grid2                from "../Grid2/Grid2";
import withVideos           from "../HigherOrderComponents/Videos/withVideos";
import withWindowWidth      from "../HigherOrderComponents/Utility/withWindowWidth";
import withStaticLoader     from "../HigherOrderComponents/Utility/withStaticLoader";

const TilePadding = Flux.Constants.Grid2.TilePadding;

class VideoTrendsGrid extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		if (!this.props.videos) {
			return null;
		}

		const videos = [...this.props.videos];

		const tileConfigs = [
			{
				index:  0,
				config: {
					badges: {textBadges: {show: {price: Flux.Guest.isLoggedIn()}, alignRight: true}},
					footer: {show: {buyBtn: !this.props.isMobile}},
					ribbon: {type: Flux.Constants.Grid2.Ribbons.TRENDING},
				},
			},
		];

		return (
			<Grid2 tileData={videos}
			       defaultTileClass={VideoTile}
			       columns={{xs: 2, sm: 3, md: 3, lg: 4}}
			       tileSizes={[{index: 0, size: 2}]}
			       tileClasses={[{index: 0, tileClass: VideoTile}]}
			       defaultTileConfig={{badges: {textBadges: {show: {price: Flux.Guest.isLoggedIn(), new: false}}}}}
			       tileConfigs={tileConfigs}
				   tilePadding={TilePadding.SMALL}
				   lazyImageLoading={this.props.lazyImageLoading}
				   headlineType={this.props.headlineType}
			/>
		);
	}
}

VideoTrendsGrid.propTypes = {
	videos:           PropTypes.array,
	isMobile:         PropTypes.bool,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.string,
};

VideoTrendsGrid.defaultProps = {
	isMobile:         false,
	lazyImageLoading: false,
};


export default withWindowWidth(withVideos(withStaticLoader(VideoTrendsGrid)));
